export default function initFloatingVideo() {
  const el = document.querySelector('#floating-video, .floatingVideo, .floating-video');
  if (!el) return;
  if (el.dataset.inited === '1') return;
  el.dataset.inited = '1';

  const MARGIN = 15;
  let dragging = false;
  let moved = false;
  let isOpen = false;
  let startX = 0, startY = 0, startLeft = 0, startTop = 0;
  let closeTarget = null;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const pt = (e) => (e.touches && e.touches[0])
    ? { x: e.touches[0].clientX, y: e.touches[0].clientY }
    : { x: e.clientX,           y: e.clientY };

  function cornersForSize(w, h) {
    const ww = document.querySelector('.page-wrapper').offsetWidth, wh = window.innerHeight;
    return [
      { left: MARGIN,           top: MARGIN },
      { left: ww - w - MARGIN,  top: MARGIN },
      { left: MARGIN,           top: wh - h - MARGIN },
      { left: ww - w - MARGIN,  top: wh - h - MARGIN }
    ];
  }

  function nearestCorner(left, top, w, h) {
    const cs = cornersForSize(w, h);
    const cx = left + w / 2, cy = top + h / 2;
    let best = cs[0], bestd = Infinity;
    cs.forEach((c) => {
      const dx = (c.left + w / 2) - cx;
      const dy = (c.top  + h / 2) - cy;
      const d = dx * dx + dy * dy;
      if (d < bestd) { bestd = d; best = c; }
    });
    return best;
  }

  function open() {
    if (isOpen) return;
    const r = el.getBoundingClientRect();
    closeTarget = nearestCorner(r.left, r.top, r.width, r.height);
    isOpen = true;
    el.classList.add('is-open');
    el.style.transition = 'all 800ms var(--smooth)';
    el.style.left = '50%';
    el.style.top = '50%';
    el.style.right = 'auto';
    el.style.bottom = 'auto';
    el.style.transform = 'translate(-50%, -50%)';
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    el.classList.remove('is-open');
    const target = closeTarget || { left: window.innerWidth - el.offsetWidth - MARGIN, top: window.innerHeight - el.offsetHeight - MARGIN };
    el.style.transition = 'all 800ms var(--smooth)';
    el.style.transform = 'translate(0, 0)';
    el.style.left = `${target.left}px`;
    el.style.top  = `${target.top}px`;
  }

  function toggle() {
    if (moved) { moved = false; return; }
    isOpen ? close() : open();
  }

  function onDocumentDown(e) {
    if (!isOpen) return;
    const target = e.target;
    if (!el.contains(target)) {
      close();
    }
  }

  function onDown(e) {
    if (isOpen) return; // disable dragging while open
    if (e.button !== undefined && e.button !== 0) return; // left mouse only
    dragging = true;
    moved = false;

    const r = el.getBoundingClientRect();
    startLeft = r.left;
    startTop  = r.top;
    const p = pt(e);
    startX = p.x;
    startY = p.y;

    el.style.left = `${startLeft}px`;
    el.style.top = `${startTop}px`;
    el.style.right = 'auto';
    el.style.bottom = 'auto';
    el.style.transition = 'none';

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
  }

  function onMove(e) {
    if (!dragging) return;
    if (e.cancelable) e.preventDefault();
    const p = pt(e);
    const dx = p.x - startX;
    const dy = p.y - startY;
    if (!moved && (Math.abs(dx) > 3 || Math.abs(dy) > 3)) moved = true;
    const ww = window.innerWidth;
    const wh = window.innerHeight;
    const r = el.getBoundingClientRect();
    const w = r.width;
    const h = r.height;
    const left = clamp(startLeft + dx, MARGIN, ww - w - MARGIN);
    const top  = clamp(startTop  + dy, MARGIN, wh - h - MARGIN);
    el.style.left = `${left}px`;
    el.style.top  = `${top}px`;
  }

  function onUp() {
    if (!dragging) return;
    window.removeEventListener('mousemove', onMove);
    window.removeEventListener('mouseup', onUp);
    window.removeEventListener('touchmove', onMove);
    window.removeEventListener('touchend', onUp);

    const r = el.getBoundingClientRect();
    const w = r.width, h = r.height;
    const { left, top } = nearestCorner(r.left, r.top, w, h);
    el.style.transition = 'left 800ms var(--smooth), top 800ms var(--smooth)';
    el.style.left = `${left}px`;
    el.style.top  = `${top}px`;

    dragging = false;
  }

  function ensureInView() {
    if (isOpen) return; // keep centered
    const r = el.getBoundingClientRect();
    const w = r.width, h = r.height;
    const ww = window.innerWidth, wh = window.innerHeight;
    const left = clamp(r.left, MARGIN, ww - w - MARGIN);
    const top  = clamp(r.top,  MARGIN, wh - h - MARGIN);
    el.style.left = `${left}px`;
    el.style.top  = `${top}px`;
    el.style.right = 'auto';
    el.style.bottom = 'auto';
  }

  el.addEventListener('mousedown', onDown, { passive: true });
  el.addEventListener('touchstart', onDown, { passive: true });
  el.addEventListener('click', (e) => { e.preventDefault(); toggle(); });
  window.addEventListener('resize', ensureInView);
  document.addEventListener('mousedown', onDocumentDown, { passive: true });
  document.addEventListener('touchstart', onDocumentDown, { passive: true });
}
